// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid {
  padding: 0 !important;
}

.tabular-data .row:first-child .col {
  white-space: nowrap;
}
.tabular-data .col {
  font-size: 1.4rem;
}
@media screen and (max-width: 768px) {
  .tabular-data .col {
    font-size: 1.1rem;
  }
}
.tabular-data span {
  text-transform: uppercase;
  font-size: 1.3rem !important;
}
.tabular-data .button span {
  text-transform: uppercase;
  font-size: 1.3rem !important;
}
@media screen and (max-width: 540px) {
  .tabular-data {
    font-size: 1.1rem;
  }
  .tabular-data .button {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
  .tabular-data .button span {
    font-size: 1.2rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/overview/pending-withdrawals/pending-withdrawals.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAIQ;EACI,mBAAA;AADZ;AAKI;EACI,iBAAA;AAHR;AAKQ;EAHJ;IAIQ,iBAAA;EAFV;AACF;AAKI;EACI,yBAAA;EACA,4BAAA;AAHR;AAOQ;EACI,yBAAA;EACA,4BAAA;AALZ;AASI;EA3BJ;IA4BQ,iBAAA;EANN;EAQM;IACI,4BAAA;IACA,6BAAA;EANV;EAQU;IACI,4BAAA;EANd;AACF","sourcesContent":[".grid {\r\n    padding: 0 !important;\r\n}\r\n\r\n.tabular-data {\r\n    .row:first-child {\r\n        .col {\r\n            white-space: nowrap;\r\n        }\r\n    }\r\n\r\n    .col {\r\n        font-size: 1.4rem;\r\n\r\n        @media screen and (max-width: 768px) {\r\n            font-size: 1.1rem;\r\n        }\r\n    }\r\n\r\n    span {\r\n        text-transform: uppercase;\r\n        font-size: 1.3rem !important;\r\n    }\r\n\r\n    .button {\r\n        span {\r\n            text-transform: uppercase;\r\n            font-size: 1.3rem !important;\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 540px) {\r\n        font-size: 1.1rem;\r\n\r\n        .button {\r\n            padding-left: 2px !important;\r\n            padding-right: 2px !important;\r\n\r\n            span {\r\n                font-size: 1.2rem !important;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
